import { render, staticRenderFns } from "./BibleCloudError.vue?vue&type=template&id=1415d2c4&scoped=true&"
import script from "./BibleCloudError.vue?vue&type=script&lang=js&"
export * from "./BibleCloudError.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudError.vue?vue&type=style&index=0&id=1415d2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415d2c4",
  null
  
)

export default component.exports